import { createStyles, makeUiStyles, Theme } from '../styles/styles';
import { StylesIndexInjections } from 'common-react';

export interface RiskProgressBarStyleProps {
  size?: 'small' | 'big';
}

export default makeUiStyles((theme: Theme) => createStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  labelWrapper: {
    marginBottom: 4,
    textTransform: 'none',
  },
  riskLabel: {
    color: theme.color.greys[60],
  },
  riskInfoLabelName: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 4,
  },
  barWrapper: {
    display: 'flex',
    alignItems: 'center'
  },
  bar: {
    marginRight: 8,
    gap: 4,
    display: 'flex',
  },
  barItem: {
    width: 8,
    height: ({ size }: RiskProgressBarStyleProps) => size === 'big' ? 24 : 16,
    borderRadius: 4,
    backgroundColor: theme.color.greys[20],
  },
  barItemActive: {
    backgroundColor: theme.color.oranges[50],
  },
  value: {
    display: 'inline-block',
    color: theme.color.greys[80],
  },
  max: {
    display: 'inline-block',
    color: theme.variables.isDarkTheme ? theme.color.greys[40] : theme.color.greys[60]
  }
}), { name: 'RiskProgressBar', index: StylesIndexInjections.UI_MOLECULES });


